export default "__VITE_ASSET__D667grzy__"